export enum FiAddressTypes {
    HomeAddress = 1,
    WorkAddress = 2,
    OtherAddress = 3,
    ImportedAddress = 101,
}
